
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 0a8 8 0 108 8 8 8 0 00-8-8zm0 14.71A6.71 6.71 0 1114.71 8 6.72 6.72 0 018 14.71z","fill":"#54d28c","fill-rule":"evenodd"}}),_c('path',{attrs:{"d":"M10.55 5.45L6.82 9.18 5.45 7.82a.64.64 0 00-.91.91l1.82 1.82a.63.63 0 00.46.19.61.61 0 00.45-.19l4.19-4.19a.64.64 0 00-.91-.91z","fill":"#54d28c","fill-rule":"evenodd"}})])
          )
        }
      }
    